import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';

type Result = ModelHookResult<{
	isSunriseEnabled: boolean;
}>;

export function useIsSunriseEnabled(): Result {
	const {
		data: { isSunriseEnabled },
	} = usePsfSharePageData();

	return {
		data: {
			isSunriseEnabled,
		},
	};
}
